/**
 * COMBAT's way to DICE: the shell's DICE rail page (`website-shell` 3.3, `decisions/0203` point 5),
 * reached through the stage (`StageControls.openDice`). COMBAT has no dice window or button of its own
 * (the top bar's Dice button retired with the bar, `website-shell` 4.3; DICE is in the shell's strip);
 * a unit sheet's stat cell opens the page seeded.
 *
 * Outside the shell (a COMBAT.app mounted on its own) there is no rail, so the opener is `null`: no
 * roll buttons on the sheet.
 */
import { useStage } from "../shell/stageContext";

/** COMBAT's dice opener: the shell's DICE rail page, or null with no shell around it. */
export function useCombatDice() {
  return useStage()?.openDice ?? null;
}
